"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const analytics_js_1 = require("@hh.ru/analytics-js");
/** Нажатие кнопки на главной странице работодателей */
const employerMainPageButtonClickExternal = () => analytics_js_1.VendorAnalytics.eventToStorage("anonymous", "click", "button_publish_vacancy_top");
exports.default = employerMainPageButtonClickExternal;
